import { normalizeRestaurantId } from "./utils";

/** @returns {'admin'|'company'|'staff'|''} */
export function jwtUserType() {
  try {
    const token = typeof localStorage !== "undefined" ? localStorage.getItem("token") : null;
    if (!token) return "";
    const t = JSON.parse(atob(token.split(".")[1]));
    const ut = t?.user?.user_type;
    return ut === "admin" || ut === "company" || ut === "staff" ? ut : "";
  } catch {
    return "";
  }
}

/** Title-case tokens for UI labels (role names, permission keys). */
function titleCaseTokens(s) {
  return s
    .split(/\s+/)
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(" ");
}

/**
 * Human-readable role name: "user - view" / "user-view" → "User View".
 * Keeps spacing; does not change API payloads (display only).
 */
export function formatRoleDisplayName(name) {
  if (name == null) return "";
  const raw = String(name).trim();
  if (!raw) return "";
  const normalized = raw
    .replace(/\s*[-–—]+\s*/g, " ")
    .replace(/_/g, " ")
    .replace(/\s+/g, " ");
  return titleCaseTokens(normalized);
}

/**
 * Human-readable permission label: "user:view" → "User View".
 */
export function formatPermissionLabel(perm) {
  if (perm == null) return "";
  const raw = String(perm).trim();
  if (!raw) return "";
  const normalized = raw
    .replace(/:/g, " ")
    .replace(/\s*[-–—]+\s*/g, " ")
    .replace(/_/g, " ")
    .replace(/\s+/g, " ");
  return titleCaseTokens(normalized);
}

/** Normalize GET /v1/roles (array or paginated `{ data }`). */
export function parseRolesListResponse(res) {
  const d = res?.data;
  if (!d) return [];
  if (Array.isArray(d)) return d;
  if (Array.isArray(d.data)) return d.data;
  return [];
}

/**
 * POST /v1/roles returns a single role or `{ roles: [...], count }` after bulk create.
 * Pick the role row for `storeId` so assignments match the tenant.
 */
export function unwrapCreatedRoleForStore(payload, storeId) {
  const rid = normalizeRestaurantId(storeId);
  if (!payload) return null;
  if (payload._id) {
    if (!rid) return payload;
    if (!payload.restaurantId) return payload;
    return String(payload.restaurantId) === rid ? payload : null;
  }
  const list = payload.roles;
  if (!Array.isArray(list) || !list.length) return null;
  if (!rid) return list[0];
  return (
    list.find((r) => r.restaurantId && String(r.restaurantId) === rid) || list[0]
  );
}
